import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import CommonSelect from "../../../core/common/commonSelect";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import useApi from "../../../core/customhook/useApi";
import axios from "axios";
import { apibaseurl, jwttoken } from "../../../environment";
import { format } from "date-fns";
import Loader from "../../../core/common/selfLoder";
import Swal from "sweetalert2";

interface PolicyTab {
  policy_id: string;
  policy_type: string;
}

interface PolicyTabMainResponse {
  success: boolean;
  message: string;
  statusCode: string;
  data: PolicyTab[];
}

interface PolicyData {
  ID: number;
  policy_name: string;
  policy_category: string;
  slug: string;
  policy_doc: string;
}

interface PolicyDateMainResponse {
  success: boolean;
  message: string;
  statusCode: string;
  data: PolicyData[];
}

interface PolicyAcceptResponse {
  success: boolean;
  message: string;
  statusCode: string;
}

interface AcceptPolicyData {
  success: boolean;
  message: string;
  statusCode: string;
  data: {
    policy_id: number;
    accepted_date: string;
  }[];
}
const PrivacyPolicy = () => {
  const route = all_routes;
  const [acceptLoading, setAcceptLoading] = useState(false);
  const [selectedPdf, setSelectedPdf] = useState<string | null>(null);
  const [activeTab, setActiveTab] = useState("");
  const [policyAcceptData, setPolicyAcceptData] = useState<AcceptPolicyData>({
    success: false,
    message: "",
    statusCode: "",
    data: [],
  });
  const [selectedPolicyId, setSelectedPolicyId] = useState<Number>();

  const [filter, setFilter] = useState<"all" | "accepted" | "notAccepted">("all");



  const { data: policyTabResponse, loading: typeLoading } =
    useApi<PolicyTabMainResponse>("/api/master/get-policy", {
      method: "GET",
      autoCall: true,
    });

  const { data: policyDataResponse, loading: policyDataLoading } =
    useApi<PolicyDateMainResponse>("/api/policy", {
      method: "POST",
      autoCall: true,
      payload: {
        category: activeTab,
      },
      dependencies: [activeTab],
    });

  const {
    data: acceptedPolicyResponse,
    callApi: fetchAcceptedPolicies,
    loading: acceptedPoliciesLoading,
  } = useApi<AcceptPolicyData>("/api/accepted-policy", {
    method: "GET",
    autoCall: false,
  });
  const getPolicyAcceptRsponse = async () => {
    try {
      const response = await fetchAcceptedPolicies();
      if (response) {
        const acceptedPolicies = response.data.map((item: any) => ({
          policy_id: item.policy_id,
          accepted_date: format(new Date(item.accepted_date), "dd MMMM, yyyy"),
        }));
        setPolicyAcceptData({
          ...response,
          data: acceptedPolicies,
        });
      }
    } catch (error) {
      console.log("Error fetching accepted policies:", error);
    }
  };

  useEffect(() => {
    getPolicyAcceptRsponse();
  }, []);

  const { callApi: acceptPolicyApi } = useApi<PolicyAcceptResponse>(
    "/api/accept-policy",
    {
      method: "POST",
      autoCall: false,
    }
  );
  const handleAccept = async (policyId: number) => {
    const confirmResult = await Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to accept this policy?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, accept it!",
    });

    if (!confirmResult.isConfirmed) return;

    try {
      setAcceptLoading(true);

      const response = await acceptPolicyApi({ policy_id: policyId });

      if (response?.success) {
        await getPolicyAcceptRsponse();
        Swal.fire({
          title: "Accepted!",
          text: "You have successfully accepted the policy.",
          icon: "success",
          timer: 2000,
          showConfirmButton: true,
        });
      }
    } catch (error) {
      console.error("Error accepting policy:", error);
      Swal.fire({
        title: "Error!",
        text: "Something went wrong while accepting the policy.",
        icon: "error",
      });
    } finally {
      setAcceptLoading(false);
    }
  };

  return (
    <>
      <Loader
        loading={typeLoading || policyDataLoading || acceptLoading}
      />
      <div className="page-wrapper">

        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Policies </h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to="#">
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Company Overview</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Policies
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>
          {/* /Breadcrumb */}

          {/* Tabs */}
          <div className="card">
            <div className="card-body p-3">
              <div className="d-flex align-items-center justify-content-center">
                <div
                  className="w-100"
                  style={{
                    overflowX: "auto",
                    whiteSpace: "nowrap",
                  }}
                >
                  <ul
                    className="nav nav-tabs justify-content-center flex-nowrap"
                    style={{ minWidth: "max-content", overflowY: "hidden" }}
                  >
                    <li className="nav-item d-inline-block">
                      <button
                        className="nav-link px-3 px-md-4 py-2 mb-1"
                        onClick={() => setActiveTab("")}
                        style={{
                          backgroundColor: activeTab === "" ? "#2e3294" : "transparent",
                          color: activeTab === "" ? "white" : "#2e3294",
                          border: "1px solid #2e3294",
                          borderRadius: "15px",
                          fontWeight: "500",
                        }}
                      >
                        All
                      </button>
                    </li>

                    {policyTabResponse?.data.map((tab) => (
                      <li className="nav-item d-inline-block" key={tab.policy_id}>
                        <button
                          className="nav-link px-4 py-2 mb-1"
                          onClick={() => setActiveTab(tab.policy_id)}
                          style={{
                            backgroundColor:
                              activeTab === tab.policy_id ? "#2e3294" : "transparent",
                            color:
                              activeTab === tab.policy_id ? "white" : "#2e3294",
                            border: "1px solid #2e3294",
                            borderRadius: "15px",
                            fontWeight: "500",
                          }}
                        >
                          {tab.policy_type}
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>

              </div>
            </div>
          </div>

          {/* Filter Buttons */}
          <div className="mb-4 d-flex flex-wrap gap-2">
            {([
              { label: "All", value: "all" },
              { label: "Accepted", value: "accepted" },
              { label: "Acceptance Pending", value: "notAccepted" },
            ] as const).map((btn) => {
              const value = btn.value;
              const isActive = filter === value;

              return (
                <button
                  key={value}
                  onClick={() => setFilter(value)}
                  className="btn btn-sm"
                  style={{
                    backgroundColor: isActive ? "#2e3294" : "#e6e7fa",
                    color: isActive ? "#ffffff" : "#2e3294",
                    border: "1px solid #2e3294",
                    borderRadius: "8px",
                    padding: "6px 14px",
                    fontWeight: 500,
                    transition: "all 0.3s ease",
                  }}
                >
                  {btn.label}
                </button>
              );
            })}


          </div>



          <div className="card border-0 shadow-sm">
            <div className="card-body">
              <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
                {policyDataResponse?.data && policyAcceptData?.data ? (() => {
                  const filteredPolicies = policyDataResponse.data.filter((policy) => {
                    const isAccepted = policyAcceptData.data.some(
                      (item) => item.policy_id === policy.ID
                    );

                    if (filter === "accepted") return isAccepted;
                    if (filter === "notAccepted") return !isAccepted;
                    return true;
                  });

                  if (filteredPolicies.length === 0) {
                    return (
                      <div className="col-12 text-center">
                        <p>
                          {filter === "accepted"
                            ? "No Accepted Policies found."
                            : filter === "notAccepted"
                              ? "No Pending Acceptances found."
                              : "No Policies available."}
                        </p>
                      </div>
                    );
                  }

                  return filteredPolicies.map((policy, index) => {
                    const isAccepted = policyAcceptData.data.some(
                      (item) => item.policy_id === policy.ID
                    );
                    const acceptedDate = policyAcceptData.data.find(
                      (item) => item.policy_id === policy.ID
                    )?.accepted_date;

                    return (
                      <div className="col" key={index}>
                        <div className="card h-100 border shadow-sm mb-0">
                          <div className="card-header bg-white border-bottom-0">
                            <p
                              className="mb-1"
                              style={{
                                color: "#2e3294",
                                // color: "#f0",
                                fontSize: "18px",
                                fontWeight: "500",
                              }}
                            >
                              {policy.policy_name}
                            </p>

                            <div className="text-start mt-2" style={{ fontSize: "13px" }}>
                              {isAccepted
                                ? `Accepted on ${acceptedDate}`
                                : "Acceptance Pending"}
                            </div>
                          </div>

                          <div className="card-body d-flex flex-column justify-content-between">
                            <div className="d-flex justify-content-between mt-auto">


                              <button
                                className="btn btn-sm"
                                style={{
                                  backgroundColor: isAccepted ? "#198754" : "#2e3294ad",
                                  color: "#fff",
                                  border: "none",
                                }}
                                onClick={() => handleAccept(policy.ID)}
                                disabled={isAccepted}
                              >
                                {isAccepted ? (
                                  <>
                                    <i className="bi bi-check-circle me-1"></i> Accepted
                                  </>
                                ) : (
                                  <>
                                    <i className="bi bi-check2-square me-1"></i> Accept
                                  </>
                                )}
                              </button>
                              {policy.policy_doc && (
                                <button
                                  className="btn btn-sm"
                                  style={{
                                    backgroundColor: "#2e3294",
                                    color: "#fff",
                                    border: "none",
                                  }}
                                  data-bs-toggle="modal"
                                  data-bs-target="#policyModal"
                                  onClick={() => setSelectedPdf(policy.policy_doc)}
                                >
                                  <i className="bi bi-eye me-1"></i> View
                                </button>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  });
                })() : (
                  <div className="col-12 text-center">
                    <p>Loading policies...</p>
                  </div>
                )}
              </div>

            </div>
          </div>

          {/* <div className="card">
            <div className="card-body">
              <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
                {policyDataResponse?.data &&
                  policyDataResponse.data.length > 0 ? (
                  policyDataResponse.data.map((policy, index) => {
                    const isAccepted = policyAcceptData.data.some(
                      (item) => item.policy_id === policy.ID
                    );
                    const acceptedDate = policyAcceptData.data.find(
                      (item) => item.policy_id === policy.ID
                    )?.accepted_date;

                    return (
                      <div className="col" key={index}>
                        <div className="card h-100 border shadow-sm">
                          <div className="card-header bg-white border-bottom-0">
                            <h5 className="card-title mb-1 text-primary">
                              <i className="bi bi-file-earmark-text me-2"></i>
                              {policy.policy_name}
                            </h5>
                            <span
                              className={`badge ${isAccepted ? "bg-success" : "bg-danger"
                                } mt-2`}
                            >
                              {isAccepted
                                ? `Accepted on ${acceptedDate}`
                                : "Acceptance Pending"}
                            </span>
                          </div>

                          <div className="card-body d-flex flex-column justify-content-between">
                            <div className="d-flex justify-content-between mt-auto">
                              {policy.policy_doc && (
                                <button
                                  className="btn btn-outline-primary btn-sm"
                                  data-bs-toggle="modal"
                                  data-bs-target="#policyModal"
                                  onClick={() =>
                                    setSelectedPdf(policy.policy_doc)
                                  }
                                >
                                  <i className="bi bi-eye me-1"></i> View
                                </button>
                              )}

                              <button
                                className={`btn btn-sm ${isAccepted ? "btn-success" : "btn-warning"
                                  }`}
                                onClick={() => handleAccept(policy.ID)}
                                disabled={isAccepted}
                              >
                                {isAccepted ? (
                                  <>
                                    <i className="bi bi-check-circle me-1"></i>{" "}
                                    Accepted
                                  </>
                                ) : (
                                  <>
                                    <i className="bi bi-check2-square me-1"></i>{" "}
                                    Accept
                                  </>
                                )}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <div className="col-12 text-center">
                    <p>No Policy found for this category.</p>
                  </div>
                )}
              </div>
            </div>
          </div> */}
        </div>

        {/* PDF Modal */}
        {/* {selectedPdf && selectedPolicyId && ( */}
        <div
          className="modal fade"
          id="policyModal"
          tabIndex={-1}
          aria-labelledby="policyModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="policyModalLabel">
                  Document Preview
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <iframe
                  src={selectedPdf || ""}
                  width="100%"
                  height="500px"
                  style={{ border: "none" }}
                ></iframe>
              </div>
            </div>
          </div>
        </div>
        {/* )} */}

        <div className="footer d-flex align-items-center justify-content-center bg-white border-top p-3">
          <p className="mb-0">© {new Date().getFullYear()} WeConnect. All rights reserved.</p>
        </div>
      </div>
    </>
  );
};

export default PrivacyPolicy;


// import React, { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import { all_routes } from "../../router/all_routes";
// import CommonSelect from "../../../core/common/commonSelect";
// import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
// import useApi from "../../../core/customhook/useApi";
// import axios from "axios";
// import { apibaseurl, jwttoken } from "../../../environment";
// import { format } from "date-fns";
// import Loader from "../../../core/common/selfLoder";
// import Swal from "sweetalert2";

// interface PolicyTab {
//   policy_id: string;
//   policy_type: string;
// }

// interface PolicyTabMainResponse {
//   success: boolean;
//   message: string;
//   statusCode: string;
//   data: PolicyTab[];
// }

// interface PolicyData {
//   ID: number;
//   policy_name: string;
//   policy_category: string;
//   slug: string;
//   policy_doc: string;
// }

// interface PolicyDateMainResponse {
//   success: boolean;
//   message: string;
//   statusCode: string;
//   data: PolicyData[];
// }

// interface PolicyAcceptResponse {
//   success: boolean;
//   message: string;
//   statusCode: string;
// }

// interface AcceptPolicyData {
//   success: boolean;
//   message: string;
//   statusCode: string;
//   data: {
//     policy_id: number;
//     accepted_date: string;
//   }[];
// }
// const PrivacyPolicy = () => {
//   const route = all_routes;
//   const [acceptLoading, setAcceptLoading] = useState(false);
//   const [selectedPdf, setSelectedPdf] = useState<string | null>(null);
//   const [activeTab, setActiveTab] = useState("");
//   const [policyAcceptData, setPolicyAcceptData] = useState<AcceptPolicyData>({
//     success: false,
//     message: "",
//     statusCode: "",
//     data: [],
//   });
//   const [selectedPolicyId, setSelectedPolicyId] = useState<Number>();


//   const { data: policyTabResponse, loading: typeLoading } =
//     useApi<PolicyTabMainResponse>("/api/master/get-policy", {
//       method: "GET",
//       autoCall: true,
//     });

//   const { data: policyDataResponse, loading: policyDataLoading } =
//     useApi<PolicyDateMainResponse>("/api/policy", {
//       method: "POST",
//       autoCall: true,
//       payload: {
//         category: activeTab,
//       },
//       dependencies: [activeTab],
//     });

//   const {
//     data: acceptedPolicyResponse,
//     callApi: fetchAcceptedPolicies,
//     loading: acceptedPoliciesLoading,
//   } = useApi<AcceptPolicyData>("/api/accepted-policy", {
//     method: "GET",
//     autoCall: false,
//   });
//   const getPolicyAcceptRsponse = async () => {
//     try {
//       const response = await fetchAcceptedPolicies();
//       if (response) {
//         const acceptedPolicies = response.data.map((item: any) => ({
//           policy_id: item.policy_id,
//           accepted_date: format(new Date(item.accepted_date), "dd MMMM, yyyy"),
//         }));
//         setPolicyAcceptData({
//           ...response,
//           data: acceptedPolicies,
//         });
//       }
//     } catch (error) {
//       console.log("Error fetching accepted policies:", error);
//     }
//   };

//   useEffect(() => {
//     getPolicyAcceptRsponse();
//   }, []);

//   const { callApi: acceptPolicyApi } = useApi<PolicyAcceptResponse>(
//     "/api/accept-policy",
//     {
//       method: "POST",
//       autoCall: false,
//     }
//   );
//   const handleAccept = async (policyId: number) => {
//     const confirmResult = await Swal.fire({
//       title: "Are you sure?",
//       text: "Do you really want to accept this policy?",
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonColor: "#3085d6",
//       cancelButtonColor: "#d33",
//       confirmButtonText: "Yes, accept it!",
//     });

//     if (!confirmResult.isConfirmed) return;

//     try {
//       setAcceptLoading(true);

//       const response = await acceptPolicyApi({ policy_id: policyId });

//       if (response?.success) {
//         await getPolicyAcceptRsponse();
//         Swal.fire({
//           title: "Accepted!",
//           text: "You have successfully accepted the policy.",
//           icon: "success",
//           timer: 2000,
//           showConfirmButton: true,
//         });
//       }
//     } catch (error) {
//       console.error("Error accepting policy:", error);
//       Swal.fire({
//         title: "Error!",
//         text: "Something went wrong while accepting the policy.",
//         icon: "error",
//       });
//     } finally {
//       setAcceptLoading(false);
//     }
//   };

//   return (
//     <>
//       <Loader
//         loading={typeLoading || policyDataLoading || acceptLoading}
//       />
//       <div className="page-wrapper">
//         <div className="content">
//           {/* Breadcrumb */}
//           <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
//             <div className="my-auto mb-2">
//               <h2 className="mb-1">Policies </h2>
//               <nav>
//                 <ol className="breadcrumb mb-0">
//                   <li className="breadcrumb-item">
//                     <Link to="#">
//                       <i className="ti ti-smart-home" />
//                     </Link>
//                   </li>
//                   <li className="breadcrumb-item">Dashboard</li>
//                   <li className="breadcrumb-item active" aria-current="page">
//                     Policies
//                   </li>
//                 </ol>
//               </nav>
//             </div>
//             <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
//               <div className="head-icons ms-2">
//                 <CollapseHeader />
//               </div>
//             </div>
//           </div>
//           {/* /Breadcrumb */}

//           {/* Tabs */}
//           <div className="card">
//             <div className="card-body p-3">
//               <div className="d-flex align-items-center justify-content-center">
//                 <div
//                   className="w-100"
//                   style={{
//                     overflowX: "auto",
//                     whiteSpace: "nowrap",
//                   }}
//                 >
//                   <ul
//                     className="nav nav-tabs justify-content-center flex-nowrap"
//                     style={{ minWidth: "max-content", overflowY: "hidden" }}
//                   >
//                     <li className="nav-item d-inline-block">
//                       <button
//                         className="nav-link px-3 px-md-4  py-2 rounded mb-1"
//                         onClick={() => setActiveTab("")}
//                         style={{
//                           backgroundColor:
//                             activeTab === "" ? "#F89520" : "transparent",
//                           color: activeTab === "" ? "white" : "black",
//                           border: "1px solid",
//                           borderColor: activeTab === "" ? "#F89520" : "#ddd",
//                         }}
//                       >
//                         All
//                       </button>
//                     </li>
//                     {policyTabResponse?.data.map((tab) => (
//                       <li
//                         className="nav-item d-inline-block"
//                         key={tab.policy_id}
//                       >
//                         <button
//                           className="nav-link px-4 py-2 rounded"
//                           onClick={() => setActiveTab(tab.policy_id)}
//                           style={{
//                             backgroundColor:
//                               activeTab === tab.policy_id
//                                 ? "#F89520"
//                                 : "transparent",
//                             color:
//                               activeTab === tab.policy_id ? "white" : "black",
//                             border: "1px solid",
//                             borderColor:
//                               activeTab === tab.policy_id ? "#F89520" : "#ddd",
//                           }}
//                         >
//                           {tab.policy_type}
//                         </button>
//                       </li>
//                     ))}
//                   </ul>
//                 </div>
//               </div>
//             </div>
//           </div>
//           <div className="card border-0 shadow-sm">
//             <div className="card-body">
//               <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
//                 {policyDataResponse?.data && policyDataResponse.data.length > 0 ? (
//                   policyDataResponse.data.map((policy, index) => {
//                     const isAccepted = policyAcceptData.data.some(
//                       (item) => item.policy_id === policy.ID
//                     );
//                     const acceptedDate = policyAcceptData.data.find(
//                       (item) => item.policy_id === policy.ID
//                     )?.accepted_date;

//                     return (
//                       <div className="col" key={index}>
//                         <div className="card h-100 border shadow-sm">
//                           <div className="card-header bg-white border-bottom-0">
//                             <h5
//                               className="card-title mb-1"
//                               style={{ color: "#2e3294" }}
//                             >

//                               {policy.policy_name}
//                             </h5>

//                             <div className="text-end">
//                               {isAccepted
//                                 ? `Accepted on ${acceptedDate}`
//                                 : "Acceptance Pending"}
//                             </div>
//                           </div>

//                           <div className="card-body d-flex flex-column justify-content-between">
//                             <div className="d-flex justify-content-between mt-auto">
//                               {policy.policy_doc && (
//                                 <button
//                                   className="btn btn-sm"
//                                   style={{
//                                     backgroundColor: "#2e3294c4",
//                                     color: "#fff",
//                                     border: "none",
//                                   }}
//                                   data-bs-toggle="modal"
//                                   data-bs-target="#policyModal"
//                                   onClick={() => setSelectedPdf(policy.policy_doc)}
//                                 >
//                                   <i className="bi bi-eye me-1"></i> View
//                                 </button>
//                               )}

//                               <button
//                                 className="btn btn-sm"
//                                 style={{
//                                   backgroundColor: isAccepted ? "#198754" : "#2e3294", // green if accepted
//                                   color: "#fff",
//                                   border: "none",
//                                 }}
//                                 onClick={() => handleAccept(policy.ID)}
//                                 disabled={isAccepted}
//                               >
//                                 {isAccepted ? (
//                                   <>
//                                     <i className="bi bi-check-circle me-1"></i> Accepted
//                                   </>
//                                 ) : (
//                                   <>
//                                     <i className="bi bi-check2-square me-1"></i> Accept
//                                   </>
//                                 )}
//                               </button>
//                             </div>

//                           </div>
//                         </div>
//                       </div>
//                     );
//                   })
//                 ) : (
//                   <div className="col-12 text-center">
//                     <p>No Policy found for this category.</p>
//                   </div>
//                 )}
//               </div>
//             </div>
//           </div>

//           {/* <div className="card">
//             <div className="card-body">
//               <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
//                 {policyDataResponse?.data &&
//                   policyDataResponse.data.length > 0 ? (
//                   policyDataResponse.data.map((policy, index) => {
//                     const isAccepted = policyAcceptData.data.some(
//                       (item) => item.policy_id === policy.ID
//                     );
//                     const acceptedDate = policyAcceptData.data.find(
//                       (item) => item.policy_id === policy.ID
//                     )?.accepted_date;

//                     return (
//                       <div className="col" key={index}>
//                         <div className="card h-100 border shadow-sm">
//                           <div className="card-header bg-white border-bottom-0">
//                             <h5 className="card-title mb-1 text-primary">
//                               <i className="bi bi-file-earmark-text me-2"></i>
//                               {policy.policy_name}
//                             </h5>
//                             <span
//                               className={`badge ${isAccepted ? "bg-success" : "bg-danger"
//                                 } mt-2`}
//                             >
//                               {isAccepted
//                                 ? `Accepted on ${acceptedDate}`
//                                 : "Acceptance Pending"}
//                             </span>
//                           </div>

//                           <div className="card-body d-flex flex-column justify-content-between">
//                             <div className="d-flex justify-content-between mt-auto">
//                               {policy.policy_doc && (
//                                 <button
//                                   className="btn btn-outline-primary btn-sm"
//                                   data-bs-toggle="modal"
//                                   data-bs-target="#policyModal"
//                                   onClick={() =>
//                                     setSelectedPdf(policy.policy_doc)
//                                   }
//                                 >
//                                   <i className="bi bi-eye me-1"></i> View
//                                 </button>
//                               )}

//                               <button
//                                 className={`btn btn-sm ${isAccepted ? "btn-success" : "btn-warning"
//                                   }`}
//                                 onClick={() => handleAccept(policy.ID)}
//                                 disabled={isAccepted}
//                               >
//                                 {isAccepted ? (
//                                   <>
//                                     <i className="bi bi-check-circle me-1"></i>{" "}
//                                     Accepted
//                                   </>
//                                 ) : (
//                                   <>
//                                     <i className="bi bi-check2-square me-1"></i>{" "}
//                                     Accept
//                                   </>
//                                 )}
//                               </button>
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     );
//                   })
//                 ) : (
//                   <div className="col-12 text-center">
//                     <p>No Policy found for this category.</p>
//                   </div>
//                 )}
//               </div>
//             </div>
//           </div> */}
//         </div>

//         {/* PDF Modal */}
//         {/* {selectedPdf && selectedPolicyId && ( */}
//         <div
//           className="modal fade"
//           id="policyModal"
//           tabIndex={-1}
//           aria-labelledby="policyModalLabel"
//           aria-hidden="true"
//         >
//           <div className="modal-dialog modal-lg">
//             <div className="modal-content">
//               <div className="modal-header">
//                 <h5 className="modal-title" id="policyModalLabel">
//                   Document Preview
//                 </h5>
//                 <button
//                   type="button"
//                   className="btn-close"
//                   data-bs-dismiss="modal"
//                   aria-label="Close"
//                 ></button>
//               </div>
//               <div className="modal-body">
//                 <iframe
//                   src={selectedPdf || ""}
//                   width="100%"
//                   height="500px"
//                   style={{ border: "none" }}
//                 ></iframe>
//               </div>
//             </div>
//           </div>
//         </div>
//         {/* )} */}

//         <div className="footer d-flex align-items-center justify-content-center bg-white border-top p-3">
//           <p className="mb-0">© {new Date().getFullYear()} WeConnect. All rights reserved.</p>
//         </div>
//       </div>
//     </>
//   );
// };

// export default PrivacyPolicy;
